import { Group, Select, SelectProps } from '@mantine/core';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import DEFAULT_ICONS from 'src/Components/Shared/IconSelect/icons';

import styles from './IconSelect.module.scss';
import { Props } from './IconSelect.types';

const IconSelect = ({ icons = DEFAULT_ICONS, ...props }: Props) => {
  const { t } = useTranslation();
  const IconComponent = icons[props.value as string];

  const renderSelectOption: SelectProps['renderOption'] = ({ option }) => {
    const OptionIcon = icons[option.value];
    return (
      <Group flex="1" gap="xs" justify={'center'} className={styles.group}>
        {OptionIcon && <OptionIcon className={styles.icon} />}
      </Group>
    );
  };

  return (
    <Select
      {...props}
      className={classnames(props.className, styles.container)}
      classNames={{
        option: styles.option,
        input: styles.input,
        section: styles.selectedIcon,
      }}
      placeholder={t('iconSelect.placeholder', 'Icône')}
      data={Object.keys(icons).map(key => ({ value: key, label: key }))}
      renderOption={renderSelectOption}
      leftSection={IconComponent && <IconComponent />}
      leftSectionPointerEvents="none"
    />
  );
};

export default IconSelect;
